import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./image-object.module.css";
export const ImageObject = ({ image  })=>/*#__PURE__*/ _jsx("img", {
        src: image.filename,
        alt: image.alt ?? "",
        className: styles.image
    });
